import React from "react";
import ufpbLogo from "../../../../assets/images/ufpb.png";
import ministerios from "../../../../assets/images/ministerios.svg";
import CNPQlogo from "../../../../assets/images/cnpq-logo-7.png";
import { Header } from "../styles";

import {
  SupportersSessionContainer,
  SupportersSessionImgsWrapper,
  SupporterImgUfpb,
  SupporterImgMinis,
  SupporterSessionLink,
  SupporterImgCNPQ,
} from "./styles";

function SupportersSession() {
  return (
    <>
      <SupportersSessionContainer>
        <Header>Apoiadores</Header>
        <SupportersSessionImgsWrapper>
          <SupporterSessionLink>
            <SupporterImgUfpb src={ufpbLogo} />
          </SupporterSessionLink>
          <SupporterSessionLink>
            <SupporterImgCNPQ src={CNPQlogo} />
          </SupporterSessionLink>
          <SupporterSessionLink>
            <SupporterImgMinis src={ministerios} />
          </SupporterSessionLink>
        </SupportersSessionImgsWrapper>
      </SupportersSessionContainer>
    </>
  );
}

export default SupportersSession;

/**
 * <SupportersSessionContainer>
        <Header>Apoiadores</Header>
        <SupportersSessionImgsWrapper>
          <SupporterSessionLink
            href="https://ufpb.br/"
            target="_blank"
            aria-label="Ufpb"
          >
            <SupporterImgUfpb src={ufpbLogo} />
          </SupporterSessionLink>
          <SupporterSessionLink
            href="https://www.gov.br/cnpq/pt-br"
            target="_blank"
            aria-label="CNPQ"
          >
            <SupporterImgCNPQ src={CNPQlogo} />
          </SupporterSessionLink>
          <SupporterSessionLink
            href="https://www.gov.br/saude/pt-br"
            onClick={() =>
              window.open("https://www.gov.br/mec/pt-br", "_blank")
            }
            aria-label="Ministérios"
          >
            <SupporterImgMinis src={ministerios} />
          </SupporterSessionLink>
        </SupportersSessionImgsWrapper>
      </SupportersSessionContainer>
 */
